import React, { FC } from 'react';

import {
  FormFieldsColorRow,
  FormFieldsTitleStyleSection,
  FormFieldsUploadSection
} from '../../components';

import {
  BACKGROUND_COLOR_FIELD,
  BAR_BACKGROUND_IMAGE_UPLOAD_FIELD,
  BORDER_COLOR_FIELD,
  FONT_WEIGHT_OPTIONS,
  MILESTONE_UPLOAD_FIELDS,
  SUBTITLE_DEFAULTS,
  TITLE_DEFAULTS
} from '../ProgressBarFormFields.consts';

import { ProgressBarDesignSection } from './ProgressBarDesignSection';
import { ProgressBarFrameSection } from './ProgressBarFrameSection';

export const MilestoneProgressBarFields: FC = (): React.ReactElement => (
  <React.Fragment>
    <ProgressBarFrameSection>
      <FormFieldsColorRow fields={[BACKGROUND_COLOR_FIELD]} spacing="sm" />
      <FormFieldsUploadSection
        fields={[BAR_BACKGROUND_IMAGE_UPLOAD_FIELD]}
        spacing="lg"
      />
    </ProgressBarFrameSection>

    <FormFieldsTitleStyleSection
      heading="Title"
      nameField="title"
      colorField="fontColor"
      sizeField="fontSize"
      weightField="fontWeight"
      fontWeightOptions={FONT_WEIGHT_OPTIONS}
      fontWeightButtonDataTestId="offer-design-progress-bar-title-font-weight-button"
      fontWeightListDataTestId="offer-design-progress-bar-title-font-weight-list"
      defaults={TITLE_DEFAULTS}
      showSeparator
    />
    <FormFieldsTitleStyleSection
      heading="Subtitle"
      nameField="subTitleText"
      nameLabel="Subtitle"
      colorField="subTitleFontColor"
      sizeField="subTitleFontSize"
      weightField="subTitleFontWeight"
      fontWeightOptions={FONT_WEIGHT_OPTIONS}
      fontWeightButtonDataTestId="offer-design-progress-bar-subtitle-font-weight-button"
      fontWeightListDataTestId="offer-design-progress-bar-subtitle-font-weight-list"
      defaults={SUBTITLE_DEFAULTS}
    />

    <ProgressBarDesignSection
      gradientFields={[BORDER_COLOR_FIELD]}
      uploadFields={MILESTONE_UPLOAD_FIELDS}
    />
  </React.Fragment>
);
